export class ActivityUserReportDto {}
